import { render, staticRenderFns } from "./cooperation-detail-head-cp.vue?vue&type=template&id=12e6d8e8&scoped=true&"
import script from "./cooperation-detail-head-cp.vue?vue&type=script&lang=js&"
export * from "./cooperation-detail-head-cp.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-detail-head-cp.vue?vue&type=style&index=0&id=12e6d8e8&scoped=true&lang=scss&"
import style1 from "./cooperation-detail-head-cp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6d8e8",
  null
  
)

export default component.exports